import { useMemo } from "react";
import PropTypes from "prop-types";
import Tooltip from "@shared/v2/Tooltip";
import RingChart from "@shared/v2/RingChart";
import { useTheme } from "../../../reducers/layoutReducer/selectors";
import InnerRing from "./InnerRing";
import FunnelRingLabel from "./FunnelRingLabel";

const FunnelRing = ({ agentId, data, filters, title, tooltip, dateRange, size, showTitle }) => {
  const isPlace = useTheme().name === "place-theme";
  const ringChartData = useMemo(() => {
    const { goal, actual, onTarget } = data;
    if (goal === 0) return [];
    return [
      { value: onTarget / goal, color: isPlace ? "#C8D9FA" : "#BDE7E7" },
      { value: actual / goal, color: isPlace ? "#3270FA" : "#59C4C4" },
    ];
  }, [data, isPlace]);
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-mt-[-20px]">
      {showTitle && (title || tooltip) && <FunnelRingLabel title={title} tooltip={tooltip} />}
      <Tooltip
        className={size === "small" ? "tw-w-[84px] tw-h-[84px]" : "tw-w-[104px] tw-h-[104px]"}
        innerClassName="tw-min-w-[160px]"
        trigger={
          <RingChart data={ringChartData} size={size === "small" ? 84 : 104}>
            <InnerRing
              size={size}
              agentId={agentId}
              filters={filters}
              goal={data.goal}
              value={data.actual}
              title={title}
              dateRange={dateRange}
            />
          </RingChart>
        }
        content={
          <div className="tw-flex tw-flex-col tw-gap-[8px]">
            <div className="tw-flex tw-justify-between">
              <span>{title}:</span>
              <span>{data.actual.toLocaleString()}</span>
            </div>
            <div className="tw-flex tw-justify-between">
              <span>On Target:</span>
              <span>{data.onTarget.toLocaleString()}</span>
            </div>
            <div className="tw-flex tw-justify-between">
              <span>Total Goal:</span>
              <span>{data.goal.toLocaleString()}</span>
            </div>
          </div>
        }
      />
    </div>
  );
};

FunnelRing.propTypes = {
  agentId: PropTypes.number,
  data: PropTypes.shape({
    actual: PropTypes.number,
    goal: PropTypes.number,
    onTarget: PropTypes.number,
  }),
  dateRange: PropTypes.string.isRequired,
  filters: PropTypes.shape().isRequired,
  title: PropTypes.string.isRequired,
  tooltip: PropTypes.node,
  size: PropTypes.oneOf(["small", "medium"]),
  showTitle: PropTypes.bool,
};

FunnelRing.defaultProps = {
  agentId: undefined,
  data: { actual: 0, goal: 0, onTarget: 0 },
  tooltip: null,
  size: "medium",
  showTitle: true,
};

export default FunnelRing;
